import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { $serializer3jdzxb1e73v0d as $serializer } from './EntryChange.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.CollectionChanges', null, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('changes', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer_0().new_com_lightningkite_services_database_CollectionChanges_$serializer_5iduui_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer_0() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_CollectionChanges_$serializer_5o9nw6_k$();
      }
      static new_com_lightningkite_services_database_CollectionChanges_$serializer_5o9nw6_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.CollectionChanges', $this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('changes', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_1la5fd_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.changes_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, new (ArrayListSerializer())($serializer().new_com_lightningkite_services_database_EntryChange_$serializer_fcbv71_k$(this.typeSerial0__1)), value.changes_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_1la5fd_k$(encoder, value instanceof CollectionChanges() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ArrayListSerializer())($serializer().new_com_lightningkite_services_database_EntryChange_$serializer_fcbv71_k$(this.typeSerial0__1)), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, new (ArrayListSerializer())($serializer().new_com_lightningkite_services_database_EntryChange_$serializer_fcbv71_k$(this.typeSerial0__1)), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CollectionChanges().new_com_lightningkite_services_database_CollectionChanges_ncp36t_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ArrayListSerializer())($serializer().new_com_lightningkite_services_database_EntryChange_$serializer_fcbv71_k$(this.typeSerial0__1))];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_CollectionChanges_$serializer_5iduui_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_CollectionChanges_$serializer_5o9nw6_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var CollectionChangesClass;
function CollectionChanges() {
  if (CollectionChangesClass === VOID) {
    class $ {
      constructor(changes) {
        Companion_getInstance();
        var tmp;
        if (changes === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = changes;
        }
        changes = tmp;
        this.changes_1 = changes;
      }
      toString() {
        return 'CollectionChanges(changes=' + toString(this.changes_1) + ')';
      }
      hashCode() {
        return hashCode(this.changes_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CollectionChanges()))
          return false;
        if (!equals(this.changes_1, other.changes_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_CollectionChanges_ncp36t_k$(seen0, changes, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.changes_1 = emptyList();
        } else
          $this.changes_1 = changes;
        return $this;
      }
    }
    initMetadataForClass($, 'CollectionChanges', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    CollectionChangesClass = $;
  }
  return CollectionChangesClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance2slzm1chafr5y,
};
//endregion

//# sourceMappingURL=CollectionChanges.mjs.map
